import axios from "axios";
import { waPhone } from "./templateRender";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "cpn_team_token";
const USER_KEY = "cpn_team_user";

export const teamToken = () => localStorage.getItem(TOKEN_KEY);
export const teamHeaders = () => {
  const t = teamToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const teamApi = {
  async loginStep1(email, password) {
    const { data } = await axios.post(`${API}/team/login/step1`, { email, password });
    return data; // { challenge_token, expires_in, step:2 }
  },
  async loginStep2(challenge_token, otp) {
    const { data } = await axios.post(`${API}/team/login/step2`, { challenge_token, otp });
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(
      USER_KEY,
      JSON.stringify({ id: data.id, email: data.email, name: data.name }),
    );
    return data;
  },
  logout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
  me() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || "null");
    } catch {
      return null;
    }
  },
};

export function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}

export function buildOnboardUrl(invite) {
  return `${window.location.origin}/onboard/${invite.cp_name_slug}/${invite.token}`;
}

export function buildOnboardWhatsappHref(invite, cp) {
  const url = buildOnboardUrl(invite);
  const name = cp?.name || invite?.cp_name || "there";
  const msg = `Hi ${name}, welcome to ChannelPartner.Network! Yeh raha aapka personal onboarding link — 15-20 min ka short session, apni suvidha ke hisaab se time choose kar sakte ho: ${url}`;
  return `https://wa.me/${waPhone(cp?.phone)}?text=${encodeURIComponent(msg)}`;
}
